import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useExpress from '../../repository/react-query/useExpress';
import generateReport from '../../repository/route-sessions/delivery-reports/generateDeliveryReport';
import deleteReport from '../../repository/route-sessions/delivery-reports/deleteDeliveryReport';

const baseEndpoint = '/processed-fluid/route-sessions';
const reportEndpoint = 'processed-fluid/route-sessions';

/**
 * Fetch the required number of seals for the current region.
 * Returns { required_seals: number } from the backend.
 * Cached with staleTime: Infinity since this is a static per-deployment value.
 */
export const useFetchRequiredSeals = ({ enabled = true } = {}) => {
    const queryFn = useExpress({ endpoint: `${baseEndpoint}/required-seals` });
    return useQuery({
        queryKey: ['processed-fluid-required-seals'],
        queryFn,
        enabled,
        staleTime: Infinity,
    });
};

const documentsKey = (routeSessionId) => ['processed-fluid-documents', routeSessionId];

export const useFetchProcessedFluidDocuments = ({ routeSessionId, enabled = true }) => {
    const queryFn = useExpress({ endpoint: `${baseEndpoint}/documents/${routeSessionId}` });
    return useQuery({
        queryKey: documentsKey(routeSessionId),
        queryFn,
        enabled: enabled && !!routeSessionId,
    });
};

const useDocumentMutation = ({ routeSessionId, request }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ key }) => request({ resourceId: routeSessionId, report: key, endPoint: reportEndpoint }),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: documentsKey(routeSessionId) }),
    });
};

export const useGenerateProcessedFluidDocument = ({ routeSessionId }) => useDocumentMutation({ routeSessionId, request: generateReport });

export const useDeleteProcessedFluidDocument = ({ routeSessionId }) => useDocumentMutation({ routeSessionId, request: deleteReport });
